/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgShuffle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.1196 6.38637C12.7641 6.7419 12.1876 6.7419 11.8321 6.38637C11.4766 6.03084 11.4766 5.45441 11.8321 5.09888L12.3741 4.55691H12.2616C12.1849 4.57549 12.1059 4.58506 12.026 4.58506H3.99442C3.31562 4.58506 2.79653 5.19199 2.79653 5.91273V7.38014C2.79653 7.93146 2.3496 8.37838 1.79829 8.37838C1.24698 8.37838 0.800049 7.93146 0.800049 7.38014V5.91273C0.800049 4.1678 1.95801 2.6884 4.39372 2.6884H12.3264L11.8321 2.19413C11.4766 1.83859 11.4766 1.26216 11.8321 0.90663C12.1876 0.5511 12.7641 0.551103 13.1196 0.906637L15.2157 3.00277C15.5712 3.3583 15.5712 3.93473 15.2157 4.29026L13.1196 6.38637Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.16282 9.61171C3.51836 9.25617 4.09479 9.25617 4.45032 9.61171C4.80585 9.96724 4.80585 10.5437 4.45032 10.8992L3.90836 11.4412H4.02081C4.09746 11.4226 4.17652 11.413 4.25643 11.413H12.288C12.9668 11.413 13.4859 10.8061 13.4859 10.0854V8.61793C13.4859 8.06662 13.9328 7.61969 14.4841 7.61969C15.0354 7.61969 15.4824 8.06662 15.4824 8.61793V10.0854C15.4824 11.8303 14.3244 13.3097 11.8887 13.3097H3.95605L4.45033 13.804C4.80585 14.1595 4.80585 14.7359 4.45032 15.0914C4.09478 15.447 3.51835 15.447 3.16282 15.0914L1.06671 12.9953C0.711184 12.6398 0.711185 12.0633 1.06672 11.7078L3.16282 9.61171Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgShuffle
